export * from './aside.directive';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/directives/aside/index.ts